"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Halon = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");
var ui_icon_1 = require("@hopin-team/ui-icon");
var ui_spinner_1 = require("@hopin-team/ui-spinner");
var react_1 = tslib_1.__importDefault(require("react"));
var root_1 = require("./styled/root");
var Halon = function (_a) {
    var __UIScope = _a.__UIScope, ariaLabel = _a["aria-label"], testID = _a["data-testid"], className = _a.className, _b = _a.color, color = _b === void 0 ? 'grey-600' : _b, isSquare = _a.isSquare, icon = _a.icon, iconColor = _a.iconColor, iconScale = _a.iconScale, isLoading = _a.isLoading, _c = _a.scale, scale = _c === void 0 ? 8 : _c, spinnerTheme = _a.spinnerTheme;
    var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
        block: 'Halon',
        className: className,
        __UIScope: __UIScope,
    }).rootClasses;
    var a11yProps = {};
    if (ariaLabel) {
        a11yProps['aria-label'] = ariaLabel;
    }
    else {
        a11yProps['aria-hidden'] = true;
    }
    return (react_1.default.createElement(root_1.Root, tslib_1.__assign({ className: rootClasses, "data-testid": testID, color: color, scale: scale, isSquare: isSquare }, a11yProps),
        isLoading && react_1.default.createElement(ui_spinner_1.Spinner, { isShowing: true, pattern: spinnerTheme }),
        !isLoading && icon && (react_1.default.createElement(ui_icon_1.Icon, { name: icon, title: icon, color: iconColor, scale: iconScale, "aria-hidden": true }))));
};
Halon.displayName = 'Halon';
var HalonWithSpace = (0, ui_helper_with_space_1.withSpace)(Halon);
exports.Halon = HalonWithSpace;
//# sourceMappingURL=halon.js.map